import React from 'react';
import Logo from '../Logo/PrinterPeoplelogo.png';
import QRCODE from '../QRCODE/PP-QRCODE.png';


const BillPrint = ({ onClose, labelData }) => {
    const containerStyleN = {
        border: 'none',
        padding: '10px',
        width: '94%',
        marginTop: '10px',
        marginLeft: '10px',
        marginRight: '0px',
    };

    const containerStyle = {
        border: '1px solid #000',
        padding: '5px',
        width: '100%',
        marginTop: '5px',
        marginLeft: '0px',
        marginRight: '5px',
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        textAlign: 'center',
    };

    const cellStyle = {
        border: '1px solid #000',
        padding: '0px',
    };

    const cellStyleN = {
        border: 'none',
        padding: '0px',
    };

    const cellStyleN1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
    };

    const cellStyleP = {
        borderBottom: 'none',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
    };

    const cellStyleP1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
    };

    const cellStyleL = {
        borderBottom: 'none',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: 'none',
        padding: '0px',
    };

    const cellStyleL1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: 'none',
        padding: '0px',
    };

    const headerStyle = {
        color: 'blue',
        fontStyle: 'italic',
        fontFamily: 'Newtown, sans-serif',
        textAlign: 'center',
    };

    const labelStyle = {
        marginTop: '5px',
        fontFamily: 'Arial',
        fontSize: '12px',
        marginRight: '5px',
    };

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred ' + convert(num % 100).trim();
            if (num < 100000) return (convert(Math.floor(num / 1000)) + ' Thousand ' + convert(num % 1000)).trim();
            if (num < 1000000) return (convert(Math.floor(num / 100000)) + ' Lakh ' + convert(num % 100000)).trim();
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };

    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };

    return (
        <div style={containerStyleN}>
            {labelData && (
                <>
                    <div>
                        <div style={{ textAlign: 'center', marginBottom: '0px' }}>
                            <img src={Logo} alt="Company Logo" style={{ maxHeight: '80px', margin: '0 auto', width: '103%', height: '75%' }} />
                        </div>
                        <br></br>
                        <h4 style={{ textAlign: 'center', marginTop: '1px', marginBottom: '0px' }}>TAX INVOICE</h4>
                    </div>

                    <table style={tableStyle}>
                        <tbody>
                            <tr>

                                <td style={{ ...cellStyle, width: '72%', textAlign: 'left' }}>
                                    <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>Customer Name & Address</h5>
                                    <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>{labelData.SalePrint.Customer}</h5>
                                    {labelData.SalePrint.CustomerAddress ? (
                                        <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>{labelData.SalePrint.CustomerAddress} &nbsp;{labelData.SalePrint.LandMark} &nbsp;{labelData.SalePrint.PinCode}</h5>
                                    ) : (
                                        <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px', visibility: 'hidden' }}>Customer Address: Not Available</h5>
                                    )}

                                    {labelData.SalePrint.ContactNumber ? (
                                        <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>Contact Number: {labelData.SalePrint.ContactNumber}</h5>
                                    ) : (
                                        <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px', visibility: 'hidden' }}>GST Number: Not Available</h5>
                                    )}
                                </td>
                                <td style={{ ...cellStyle, width: '28%', textAlign: 'right' }}>
                                    <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5px', marginRight: '10px' }}>Invoice No: {labelData.SalePrint.InvoiceNumber}</h5>
                                    <h5 style={{ textAlign: 'left', margin: '0', marginLeft: '5px' }}>&nbsp;Invoice Date: {new Date(labelData.SalePrint.InvoiceDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    })}</h5>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <td style={{ ...cellStyle, width: '10%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>HSN</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '34%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>Description</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '17%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>Details</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>QTY</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '6%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>Rate</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '7%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>Amount</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>GST%</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>CGST</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>SGST</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '13%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>TOTAL</h6>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            {labelData && labelData.SalePrintItems.map((record, index) => {
                                const isLastRecord = index === labelData.SalePrintItems.length - 1;
                                const isFirstRecord = index === 0; // Check if it's the first record

                                return (
                                    <tr key={index} style={{ height: '20px' }}>
                                        <td style={{ ...cellStyleP, width: '10%', height: '20px', textAlign: 'left', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <div style={{ marginLeft: '5px' }}>
                                                <label style={labelStyle}>
                                                    {record.HSNCODE}
                                                </label>
                                            </div>
                                        </td>
                                        <td style={{ ...cellStyleP, width: '34%', height: '20px', textAlign: 'left', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <div style={{ marginLeft: '5px' }}>
                                                <label style={{
                                                    marginTop: '5px',
                                                    fontFamily: 'Arial',
                                                    fontSize: '12px',
                                                    textAlign: 'left',
                                                    wordWrap: 'break-word',
                                                    whiteSpace: 'normal'
                                                }}>
                                                    {record.spare}
                                                </label>
                                            </div>
                                        </td>
                                        {isFirstRecord && (
                                            <td rowSpan={labelData.SalePrintItems.length} style={{ ...cellStyleP, width: '17%', height: '20px', textAlign: 'left', borderBottom: '1px solid black' }}>
                                                <div style={{ marginLeft: '5px', marginTop: '-265px' }}>
                                                    <label style={{
                                                        marginTop: '5px',
                                                        fontFamily: 'Arial',
                                                        fontSize: '12px',
                                                        textAlign: 'left',
                                                        alignItems: 'self-start',
                                                        alignContent: 'flex-start',
                                                        wordWrap: 'break-word',
                                                        whiteSpace: 'normal'
                                                    }}>
                                                        {labelData.SalePrint.Details}
                                                    </label>
                                                </div>
                                            </td>
                                        )}


                                        <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'center', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.Quantity !== 0 ? record.Quantity : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, width: '6%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.Rate !== 0 ? record.Rate.toFixed(2) : ''}
                                            </label>
                                        </td>

                                        <td style={{ ...cellStyleP, width: '7%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {(record.Rate * record.Quantity) !== 0 ? (record.Rate * record.Quantity).toFixed(2) : ''}
                                            </label>
                                        </td>

                                        <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'center', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.GST !== 0 ? record.GST : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.CGRate !== 0 ? record.CGRate.toFixed(2) : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.SGRate !== 0 ? record.SGRate.toFixed(2) : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, width: '13%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={labelStyle}>
                                                {record.Amount !== 0 ? record.Amount.toFixed(2) : ''}
                                            </label>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>


                    </table>

                    <table style={tableStyle}>
                        <tbody >
                            <tr>

                                <td style={{ ...cellStyle, textAlign: 'left', marginTop: '-55px', maxHeight: '30%', width: '72%' }}>
                                    <br></br>
                                    <h5 style={{ marginRight: '10px', marginTop: '-5px', marginLeft: '20px' }}>BANK   : FEDERAL BANK</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-10px', marginLeft: '20px' }}>BRANCH : ERNAKULAM NORTH</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-10px', marginLeft: '20px' }}>A/c No : 10040200030884</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-10px', marginLeft: '20px' }}>IFSC   : FSRL0001004</h5>
                                    <div style={{ textAlign: 'center', marginTop: '-20%', marginLeft: '20px' }}>
                                        <img src={QRCODE} alt="QRCODE" style={{ maxHeight: '250px', margin: '0 auto', width: '35%', marginLeft: '50%', marginTop: '-35px' }} />
                                    </div>
                                </td>

                                <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, maxHeight: '30%', width: '17%' }}>
                                    <br></br>
                                    <h5 style={{ marginRight: '10px', marginTop: '-5px' }}>Net Value</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-15px' }}>CGST Amount</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-15px' }}>SGST Amount</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-15px' }}>IGST Amount</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-15px' }}>Packing Charges</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-15px' }}>Discount</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-15px' }}>Round Off</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-15px' }}>Grand Total</h5>


                                </td>

                                <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, maxHeight: '30%', width: '11%' }}>
                                    <br></br>
                                    <h5 style={{ marginRight: '10px', marginTop: '-5px' }}>{labelData.SalePrint.NetAmount.toFixed(2)}</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-15px' }}>{labelData.SalePrint.CGSTAmount.toFixed(2)}</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-15px' }}>{labelData.SalePrint.SGSTAmount.toFixed(2)}</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-15px' }}>{labelData.SalePrint.IGSTAmount.toFixed(2)}</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-15px' }}>{labelData.SalePrint.IGSTAmount.toFixed(2)}</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-15px' }}>{labelData.SalePrint.DiscountPer.toFixed(2)}</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-15px' }}>{labelData.SalePrint.RoundOff.toFixed(2)}</h5>
                                    <h5 style={{ marginRight: '10px', marginTop: '-15px' }}>{labelData.SalePrint.TotalAmount.toFixed(2)}</h5>

                                </td>

                            </tr>

                        </tbody>
                    </table>
                </>
            )
            }
            <style>
                {`
                    @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            margin: 5px;
                        }
                    }
                `}
            </style>
        </div >
    );
};

export default BillPrint;
